import {
  ConversationSubscriptionMessage,
  WebsocketSubscriptionMessage,
} from './types/outboundWebsocketEvent';

export class WebsocketSubscriptions {
  private _subscriptions: WebsocketSubscriptionMessage[] = [];

  private _findSubscription(
    request: WebsocketSubscriptionMessage,
  ): WebsocketSubscriptionMessage | undefined {
    return this._subscriptions.find((subscription) => {
      // if it's a conversation judge by csid otherwise just by type.
      if (request.params.type === 'conversation') {
        return (
          (subscription as ConversationSubscriptionMessage).params.csid ===
          request.params.csid
        );
      }
      return subscription.params.type === request.params.type;
    });
  }

  getAll(): WebsocketSubscriptionMessage[] {
    return this._subscriptions;
  }

  // Handles WS subscriptions if we need to reconnect.
  // this logic will make sure we subscribe to the same WS events again.
  handleRequest(request: WebsocketSubscriptionMessage): void {
    switch (request.type) {
      case 'connection:subscribe':
        // We check if the subscribe already is in our subscriptions array unless it is of the type conversation.
        if (!this._findSubscription(request)) {
          this._subscriptions.push(request);
        }
        break;
      case 'connection:unsubscribe':
        {
          this._subscriptions = this._subscriptions.filter(
            (subscription) => subscription !== this._findSubscription(request),
          );
        }
        break;
      default:
        break;
    }
  }
}

export const websocketSubscriptions = new WebsocketSubscriptions();
